module.exports = __webpack_public_path__ + "img/hticlogo.44eed1a2.png";